import { gql } from '@apollo/client'
import { useCustomMutation } from 'utils/mutations'

// APPOINTMENT_UPDATE

const mutation = gql`
  mutation appointmentUpdate(
    $id: ID!
    $attributes: AppointmentUpdateAttributesInput
    $include_archived: Boolean = false
    $include_with: Boolean = false
    $include_location_uuid: Boolean = false
    $include_first_time_visit: Boolean = false
    $include_preferred_location_zip: Boolean = false
    $include_request_notes: Boolean = false
    $include_cost: Boolean = false
    $include_time_slots_attributes: Boolean = false
    $include_entity_type: Boolean = false
  ) {
    appointmentUpdate(id: $id, attributes: $attributes) {
      id
      archived @include(if: $include_archived)
      appointment_status: status @include(if: $include_with)
      saved_address @include(if: $include_location_uuid) {
        uuid
        address
        phone
      }
      first_time_visit @include(if: $include_first_time_visit)
      preferred_address @include(if: $include_preferred_location_zip)
      request_notes @include(if: $include_request_notes)
      cost @include(if: $include_cost) {
        deductible
        insurance_copay
        care_estimate
        copay
        user_pays
        insurance_pays
        total
      }
      time_slots @include(if: $include_time_slots_attributes) {
        ... on AsSoonAsPossible {
          id
          description
          kind
          display_kind
        }
        ... on CancelledTime {
          id
          date
          start
          start_time
          end
          end_time
          description
          kind
          display_kind
        }
        ... on SpecificTime {
          id
          date
          start
          start_time
          end
          end_time
          description
          kind
          display_kind
        }
        ... on Suggested {
          id
          date
          start
          start_time
          end
          end_time
          description
          kind
          display_kind
        }
        ... on Confirmed {
          id
          date
          start
          start_time
          end
          end_time
          description
          kind
          display_kind
        }
        ... on Pending {
          id
          date
          start
          start_time
          end
          end_time
          description
          kind
          display_kind
        }
        ... on TimeBlock {
          id
          start
          start_time
          end
          end_time
          description
          kind
          display_kind
          days {
            name
            display_name
            enabled
          }
        }
      }
      assigned_entity @include(if: $include_entity_type) {
        ... on DoctorProfileV2 {
          id
          isProvider @client
          full_name
          preferred_contact_uuid
          contacts(select: preferred) {
            address
            phone
          }
          addresses(min_confidence: 0) {
            address
            phone
            uuid
            zip
          }
          specialties {
            name
          }
        }
        ... on FacilityProfileV2 {
          id
          isFacility @client
          name
          uuid
          contacts {
            address
            phones
          }
          display_location_types
        }
      }
    }
  }
`
export default function useAppointmentUpdate() {
  const { onMutate: onAppointmentUpdate, loading } = useCustomMutation({
    mutation,
    successMessage: 'Appointment updated',
    responsePath: 'appointmentUpdate'
  })
  return { onAppointmentUpdate, loading }
}
